import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHoursOfServiceTable extends Layout {
    sourceDriverHours: DataSource;
    tableDriverHours: Table;
}
